import MartialArtsStyles from "./Martial Arts Styles";
export default MartialArtsStyles;